<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" md="9">
        <EnrolledEmployeesFilters @filter="filterBy" :loading="loading" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-btn
          :disabled="generateBtnDisabled"
          :loading="generateBtnLoading"
          depressed
          height="47"
          block
          color="primary"
          style="text-transform: unset"
          class="rounded-lg font-weight-normal"
          @click="onClickGenerate"
        >
          {{ $t("reports.generate") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="isDataGenerated">
      <v-col class="text-start" cols="12" sm="6" md="8">
        <span class="textLight--text font-weight-medium text-h5">
          {{ $t("reports.feedback.feedbackReport") }}
        </span>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-row>
          <v-col cols="12" sm="8">
            <v-text-field
              v-model="search"
              hide-details
              prepend-inner-icon="mdi-magnify"
              color="textLight"
              :placeholder="$t('course.search')"
              solo
              flat
              clearable
              class="shrink rounded-lg"
            />
          </v-col>
          <v-col cols="12" sm="4">
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  height="45"
                  block
                  depressed
                  style="text-transform: unset"
                  class="rounded-lg textLight--text font-weight-thin button"
                  v-bind="attrs"
                  v-on="on"
                  :loading="exportBtnLoading"
                >
                  <v-icon>mdi-export</v-icon>
                  {{ $t("reports.export") }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, i) in exportItems"
                  :key="i"
                  class="hand-cursor"
                >
                  <v-list-item-title @click="exportTo(item.value)">
                    <div class="d-flex align-center justify-space-between">
                      {{ item.text }}
                      <v-icon size="25" :color="item.iconColor" class="ms-2">{{
                        item.icon
                      }}</v-icon>
                    </div>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row v-if="isDataGenerated">
      <v-col
        cols="12"
        v-if="
          training && training.feedback && training.feedback.questionAnswers
        "
      >
        <div style="overflow-x: auto; overflow-y: hidden">
          <div class="d-flex">
            <div
              v-for="(qes, index) in training.feedback.questionAnswers"
              :key="index"
            >
              <div
                style="height: 180px; width: 196px"
                v-if="!qes.isDescriptive"
              >
                <FeedbackReportRatingCard
                  :feedbackReports="data"
                  :questionVal="qes"
                />
              </div>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :disabled="loading"
                  hide-details
                  v-model="formattedStartDate"
                  :label="$t('reports.chooseFromDate')"
                  class="rounded-lg"
                  flat
                  solo
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  clearable
                >
                  <v-icon slot="append" color="textLight">
                    mdi-calendar-blank-outline
                  </v-icon></v-text-field
                >
              </template>
              <v-date-picker
                color="primary"
                v-model="startDate"
                no-title
                @input="startDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :disabled="loading"
                  hide-details
                  class="rounded-lg"
                  :label="$t('reports.chooseToDate')"
                  v-model="formattedEndDate"
                  flat
                  solo
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  clearable
                >
                  <v-icon slot="append" color="textLight">
                    mdi-calendar-blank-outline
                  </v-icon></v-text-field
                >
              </template>

              <v-date-picker
                color="primary"
                v-model="endDate"
                no-title
                @input="endDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <FeedBackReportsList
          :feedbackReports="feedbackReportsData"
          :loading="loading"
          :training="training"
        />
      </v-col>
      <v-col cols="12" v-if="feedbackReportsData && feedbackReportsData.length">
        <Pagination :length="totalPages" @onPageSelect="onPagination" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import EnrolledEmployeesFilters from "../../course-module/components/EnrolledEmployeesFilters.vue";
import FeedBackReportsList from "../components/FeedbackReportsList.vue";
import FeedbackReportRatingCard from "./FeedbackReportRatingCard.vue";
import Pagination from "../../core-module/components/Pagination.vue";

import { excelExport } from "../methods/excelExport";
export default {
  components: {
    EnrolledEmployeesFilters,
    FeedBackReportsList,
    FeedbackReportRatingCard,
    Pagination,
  },
  data() {
    return {
      loading: false,
      data: [],
      feedbackReportsData: [],
      training: {},
      filterInputs: {},
      search: null,
      startDate: null,
      endDate: null,
      startDateMenu: false,
      endDateMenu: false,
      generateBtnDisabled: true,
      isDataGenerated: false,
      exportBtnLoading: false,
      generateBtnLoading: false,
      exportItems: [
        {
          value: "xl",
          text: this.$t("reports.exportTo"),
          icon: "mdi-microsoft-excel",
          iconColor: "success",
        },
        // {
        //   value: "pdf",
        //   text: this.$t("reports.exportTo"),
        //   icon: "mdi-file-pdf-box",
        //   iconColor: "error",
        // },
      ],
      variables: {
        limit: 10,
        skip: 0,
      },
      totalCount: null,
      debounceSearch: null,
      totalPages: 0,
    };
  },
  computed: {
    isOrganizationManager() {
      return (
        this.$store.state.authenticatedUser?.isOrganizationManager ?? false
      );
    },
    formattedStartDate: {
      get() {
        return this.startDate
          ? this.$moment(this.startDate).format("DD/MM/YYYY")
          : "";
      },
      set(value) {
        this.startDate = value;
      },
    },
    formattedEndDate: {
      get() {
        return this.endDate
          ? this.$moment(this.endDate).format("DD/MM/YYYY")
          : "";
      },
      set(value) {
        this.endDate = value;
      },
    },
  },
  apollo: {
    getFeedbackReports() {
      return {
        query: require("../api/query/getFeedbackReports.gql"),
        variables: this.variablesDefaultValue(),
        skip: () => true,
        result({ data, loading }) {
          if (
            data &&
            data.getFeedbackReports &&
            data.getFeedbackReports.feedbackReports
          ) {
            // this.data = data.getFeedbackReports.feedbackReports;
            this.feedbackReportsData = data.getFeedbackReports.feedbackReports;
            this.totalCount = data.getFeedbackReports.totalCount;
            this.training = data.getFeedbackReports.training;
            let pagesVal = this.totalCount / this.variablesDefaultValue().limit;
            this.totalPages = this.checkNumberIsFloat(pagesVal)
              ? Math.ceil(pagesVal)
              : pagesVal;
          }
          this.loading = loading;
        },
      };
    },
  },
  watch: {
    search: {
      immediate: false,
      handler() {
        clearTimeout(this.debounceSearch);
        this.debounceSearch = setTimeout(() => {
          this.apiSearch(this.search);
        }, 500);
      },
    },

    startDate() {
      if (this.startDate && this.endDate) {
        this.filterInputs.dateFrom = this.startDate;
        this.filterInputs.dateTo = this.endDate;
      } else if (!this.startDate || !this.endDate) {
        delete this.filterInputs?.dateFrom;
        delete this.filterInputs?.dateTo;
      }
      this.variables = this.variablesDefaultValue();
      this.refetch();
    },
    endDate() {
      if (this.startDate && this.endDate) {
        this.filterInputs.dateFrom = this.startDate;
        this.filterInputs.dateTo = this.endDate;
      } else if (!this.startDate || !this.endDate) {
        delete this.filterInputs?.dateFrom;
        delete this.filterInputs?.dateTo;
      }
      this.variables = this.variablesDefaultValue();
      this.refetch();
    },
  },
  methods: {
    checkNumberIsFloat(value) {
      return Number(value) === value && value % 1 !== 0;
    },
    variablesDefaultValue() {
      return {
        limit: 10,
        skip: 0,
      };
    },
    onPagination(val) {
      if (val > 0) {
        this.variables.skip = this.variables.limit * (val - 1);
        this.refetch();
      }
    },
    filterBy(key, value) {
      if (key === "training") {
        this.search = null;
        if (!value) {
          delete this.filterInputs?.training;
        } else {
          this.filterInputs.training = value;
        }
      }
      if (key === "organization") {
        if (!value) {
          delete this.filterInputs?.organization;
        } else {
          this.filterInputs.organization = value;
        }
      }
      if (key === "category") {
        if (!value) {
          delete this.filterInputs?.trainingCategory;
        } else {
          this.filterInputs.trainingCategory = value;
        }
      }

      if (
        this.filterInputs?.training &&
        (this.filterInputs?.organization || this.isOrganizationManager) &&
        this.filterInputs?.trainingCategory
      ) {
        this.generateBtnDisabled = false;
        this.isDataGenerated = false;
      } else {
        this.generateBtnDisabled = true;
        this.isDataGenerated = false;
      }
    },
    async apiSearch(val) {
      const searchText = val?.trim() ?? "";

      if (searchText.length > 0) {
        this.filterInputs.search = searchText;
        this.variables = this.variablesDefaultValue();
        await this.refetch();
      } else if (searchText.length === 0 && this.filterInputs?.search != null) {
        delete this.filterInputs?.search;
        this.variables = this.variablesDefaultValue();
        await this.refetch();
      }
    },
    exportTo(val) {
      if (val === "xl") this.exportToXL();
    },
    async exportToXL() {
      this.exportBtnLoading = true;
      let exportArr = await this.$apollo
        .query({
          query: require("../api/query/getFeedbackReports.gql"),
          variables: {
            limit: 0,//1000,//export limit
            skip: 0,
            filterInput: this.filterInputs,
          },
        })
        .then(result => {
          this.exportBtnLoading = false;
          let data = result?.data?.getFeedbackReports?.feedbackReports;
          if (data?.length) {
            let feedbackExportData = data.map(feedbackObj => {
              let obj = {};
              obj[this.$t("reports.feedback.date")] = feedbackObj?.startDate
                ? this.$moment(parseInt(feedbackObj.startDate)).format(
                    "DD MMM YYYY"
                  )
                : " - ";
              obj[this.$t("reports.employee")] = feedbackObj?.employee?.user
                ?.firstName
                ? `${feedbackObj.employee.user.firstName || ""} ${
                    feedbackObj.employee.user.lastName || ""
                  }`
                : " - ";
              obj[this.$t("course.trainer")] = feedbackObj?.trainer?.user
                ?.firstName
                ? `${feedbackObj.trainer.user.firstName || ""} ${
                    feedbackObj.trainer.user.lastName || ""
                  }`
                : " - ";
              if (this.training?.feedback?.questionAnswers?.length) {
                this.training.feedback.questionAnswers.map((val, index) => {
                  obj[
                    this.$t("reports.feedback.question") + " " + (index + 1)
                  ] = this.getRatingOrDescriptiveAnswer(
                    val,
                    feedbackObj.feedback.questionAnswers
                  );
                });
              }

              return obj;
            });
            return feedbackExportData;
          } else return [];
        });
      let name = "feedback-reports";
      let fileName = name.concat("-", this.$moment().unix());
      excelExport(exportArr, fileName);
    },
    getRatingOrDescriptiveAnswer(trainingFeedBack, val) {
      let findVal = val.find(obj => obj.questionId === trainingFeedBack._id);
      if (findVal?.isDescriptive) return findVal?.givenDescriptiveAnswer;
      else return findVal?.givenRating;
    },
    async fetchForRatings() {
      await this.$apollo
        .query({
          query: require("../api/query/getFeedbackReports.gql"),
          fetchPolicy: "no-cache",
          variables: {
            limit: 0,
            skip: 0,
            filterInput: this.filterInputs,
          },
        })
        .then(result => {
          this.data = result?.data?.getFeedbackReports?.feedbackReports;
        });
    },
    async onClickGenerate() {
      this.variables = this.variablesDefaultValue();
      await this.refetch();
      await this.fetchForRatings();
      this.isDataGenerated = true;
      this.generateBtnLoading = false;
    },

    async refetch() {
      await this.$apollo.queries.getFeedbackReports.refetch({
        limit: this.variables.limit,
        skip: this.variables.skip,
        filterInput: this.filterInputs,
      });
      this.$apollo.queries.getFeedbackReports.skip = false;
    },
  },
};
</script>
